<template>
    <div class="input">
        <input
            :type="type"
            :placeholder="placeholder"
            :value="value"
            :disabled="disabled"
            :required="required"
            :name="name"
            :step="step"
            :min="min"
            :max="max"
            @input="$emit('input', $event.target.value)"
            @change="$emit('change', $event)"
        />
    </div>
</template>

<script>
export default {
    props: {
        placeholder: String,
        type: {
            type: String,
            default: 'text',
        },
        value: {
            type: String,
            default: '',
        },
        name: String,
        step: [String, Number],
        min: [String, Number],
        max: [String, Number],
        disabled: [String, Boolean],
        required: [String, Boolean],
    },
};
</script>

<style lang="scss">
input[type='color'] {
    width: 70px;
    height: 50px;
    max-width: 70px;
    cursor: pointer;
}
.input {
    // display: block;
    padding: 0;
    margin: 0;
    border: none;

    &.stretch {
        display: flex;

        input {
            flex: 1;
        }
    }

    input {
        border-radius: 32px;
        padding: 9px 17px;
        border: 1px solid #9ca5b0;
        color: #2a2a2a;
        outline: none;
        transition: all 0.25s ease-in-out;
        font-size: 13px;

        &:focus {
            border: 1px solid #6c3e91;
        }

        &:disabled {
            background-color: #f8f8f8;
        }
    }

    ::placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #9ca5b0;
        opacity: 1; /* Firefox */
    }

    :-ms-input-placeholder {
        /* Internet Explorer 10-11 */
        color: #9ca5b0;
    }

    ::-ms-input-placeholder {
        /* Microsoft Edge */
        color: #9ca5b0;
    }
}

.dropdown--selected-label {
    color: #2a2a2a;
}
</style>
